import React from 'react';
import classNames from 'classnames';
import { formatShortDateFromNow } from '../../../../../utils/date-utils/dateUtils';
import { Hyperlink } from '../../../../../components/Hyperlink';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { NotificationReadStatus } from '../status/NotificationReadStatus';
import { NotificationWatcherDecisionType } from '../../../notification.types';
import { sendNotificationClickedEvent } from '../../../notificationUtils';
import { Connect } from './NotificationWatcherDecisionContainer';

type Props = {
  notification: NotificationWatcherDecisionType;
  notificationClicked: Function;
  isAlreadyRead: boolean;
};

export class RawNotificationWatcherDecision extends React.Component<Props> {
  onNotificationClicked = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const { notification, notificationClicked } = this.props;
    sendNotificationClickedEvent();
    notificationClicked(notification)(event);
  };

  render() {
    const { notification, isAlreadyRead } = this.props;
    const { watcherDecision } = this.props.notification.data;
    return (
      <Hyperlink
        className="notification-list__link"
        href={buildUrlWithParameters(notification.link, {
          source_notification_id: notification.id,
          watcher_key: watcherDecision.key,
        })}
        onClick={this.onNotificationClicked}
        data-test-id="notification-watcher-decision"
      >
        <NotificationReadStatus notificationId={notification.id} />
        <span className="notification-list__link__content">
          <span
            className={classNames('notification-watcher__title', {
              'notification-watcher__title--new': !isAlreadyRead,
            })}
          >
            {watcherDecision.query}
          </span>
          <span className="notification-watcher__decision">
            {watcherDecision.title}
          </span>
          <span className="notification-list__link__date">
            {formatShortDateFromNow(notification.date)}
          </span>
        </span>
      </Hyperlink>
    );
  }
}

export const NotificationWatcherDecision = Connect(
  RawNotificationWatcherDecision,
);
